import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useMe } from 'core/me/provider/MeProvider';

export function AdminOnlyRoute({ allowOwner = true, redirectTo = '/app/pilates/sessions' }) {
  const { me, loading } = useMe();

  if (loading) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }

  const role = me?.companyRole ?? me?.membershipRole ?? null;
  const ok = allowOwner ? role === 'ADMIN' || role === 'OWNER' : role === 'ADMIN';

  if (!ok) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
